export default {
  namespaced: true,
  state: {
    tags: [],
  },
  mutations: {
    setTags: function (state, tags) {
      state.tags = tags;
    },
  },
};
